import React from 'react';
import { Link } from 'react-router-dom';
export const LoginPage = () => {
  return <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-id="element-262">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md" data-id="element-263">
        <div data-id="element-264">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-265">
            Sign in to your account
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600" data-id="element-266">
            Or{' '}
            <Link to="/contact" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-267">
              start your free trial today
            </Link>
          </p>
        </div>
        <form className="mt-8 space-y-6" action="#" method="POST" data-id="element-268">
          <input type="hidden" name="remember" value="true" data-id="element-269" />
          <div className="rounded-md shadow-sm -space-y-px" data-id="element-270">
            <div data-id="element-271">
              <label htmlFor="email-address" className="sr-only" data-id="element-272">
                Email address
              </label>
              <input id="email-address" name="email" type="email" autoComplete="email" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" placeholder="Email address" data-id="element-273" />
            </div>
            <div data-id="element-274">
              <label htmlFor="password" className="sr-only" data-id="element-275">
                Password
              </label>
              <input id="password" name="password" type="password" autoComplete="current-password" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm" placeholder="Password" data-id="element-276" />
            </div>
          </div>

          <div className="flex items-center justify-between" data-id="element-277">
            <div className="flex items-center" data-id="element-278">
              <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-279" />
              <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900" data-id="element-280">
                Remember me
              </label>
            </div>

            <div className="text-sm" data-id="element-281">
              <a href="#" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-282">
                Forgot your password?
              </a>
            </div>
          </div>

          <div data-id="element-283">
            <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-284">
              Sign in
            </button>
          </div>
        </form>
      </div>
    </div>;
};